import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { useAuth } from "@/hooks/useAuth";

const Index = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen flex flex-col">
      <SEO
        title="Your Brand | Member Portal"
        description="Sign in to your Your Brand membership to view your pharmacy benefit, member card, and medication pricing."
      />
      <Header />

      <main className="flex-1">
        <section className="container flex flex-col items-center justify-center gap-6 py-24 text-center">
          <h1 className="max-w-2xl text-4xl font-bold tracking-tight sm:text-5xl">
            Your membership
          </h1>
          <p className="max-w-xl text-lg text-muted-foreground">
            Access your member card, search medication pricing, find a pharmacy, and manage your
            household — all in one place.
          </p>
          <Button size="lg" asChild>
            <Link to={user ? "/dashboard" : "/auth"}>
              {user ? "Go to my dashboard" : "Sign in"}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
          <p className="text-sm text-muted-foreground">
            Memberships are set up by our team. Contact support@your-branded-domain.com to get started.
          </p>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
